import { render, staticRenderFns } from "./m_multiplechoicesingle.vue?vue&type=template&id=67d42cc4&scoped=true&"
import script from "./m_multiplechoicesingle.vue?vue&type=script&lang=js&"
export * from "./m_multiplechoicesingle.vue?vue&type=script&lang=js&"
import style0 from "./m_multiplechoicesingle.vue?vue&type=style&index=0&id=67d42cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d42cc4",
  null
  
)

export default component.exports